exports.config = {
    apiKey: "AIzaSyBmkHjkH_qbey5gSXGJbwOUGWZT70vv_jQ",
    authDomain: "cucurucu-site-vtuber.firebaseapp.com",
    projectId: "cucurucu-site-vtuber",
    storageBucket: "cucurucu-site-vtuber.appspot.com",
    messagingSenderId: "915008160168",
    appId: "1:915008160168:web:2fe6f75bbb09b2a1f99d9d",
    measurementId: "G-YLJLVJ7LXQ"
}